import 'css-chunksrc/client/scenes/resourceDetailsConfiguration/styles.scss';export default {
  "resourceDetailsConfiguration": "_resourceDetailsConfiguration_1rdl0_1",
  "main": "_main_1rdl0_8",
  "tabs": "_tabs_1rdl0_14",
  "tab": "_tab_1rdl0_14",
  "selectedTab": "_selectedTab_1rdl0_34",
  "label": "_label_1rdl0_41",
  "footer": "_footer_1rdl0_48",
  "button": "_button_1rdl0_63"
};